/** Safe label for query/mutation key heads (avoids "[object Object]"). */
export function cacheKeyLabel(value: unknown): string {
  if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return "unknown";
}
